import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { List, X } from '@phosphor-icons/react';
import Sidebar from './Sidebar';
import { useAuth } from '../lib/auth';

export default function Layout() {
  const { profile } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col md:flex-row min-h-screen"
      style={{
        background: 'linear-gradient(to bottom, #6C18C9, #9653E8, #CB9EF6)',
      }}
    >
      {/* Mobile header */}
      <header className="md:hidden fixed top-0 left-0 right-0 h-[56px] flex items-center justify-between px-4 z-20 bg-white border-b border-[#E6E6E6]">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-1 text-gray-600"
          >
            {sidebarOpen ? <X size={22} /> : <List size={22} />}
          </button>
          <div className="cursor-pointer" onClick={() => navigate('/')}>
            <img src="/cscore-logo.png" alt="CScore" style={{ height: '24px', filter: 'brightness(0) saturate(100%) invert(13%) sepia(90%) saturate(5500%) hue-rotate(270deg) brightness(80%) contrast(110%)' }} />
          </div>
        </div>
        <div
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate('/settings')}
        >
          <div className="text-right">
            <p className="text-[12px] font-bold text-text leading-tight">
              {profile?.first_name?.toUpperCase()} {profile?.last_name?.toUpperCase()}
            </p>
            <p className="text-[10px] text-gray-500 leading-tight truncate max-w-[150px]">{profile?.email}</p>
          </div>
        </div>
      </header>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/30 z-[5] md:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <Sidebar user={profile} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="flex-1 md:ml-[250px] p-3 md:p-6 pt-[68px] md:pt-6">
        <div className="bg-white min-h-[calc(100vh-48px)] p-4 md:p-6" style={{ borderRadius: '12px', boxShadow: 'inset 0 0 16px 0 rgba(0,0,0,0.3)' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
